import { faHandshakeAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link } from 'react-router-dom';
import type { RowRenderProps } from 'react-table';

import { Pill } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';

interface IProps extends RowRenderProps {
  id: string;
  linkToItem?: boolean;
}

function PartnerChip({ id, linkToItem = true }: IProps) {
  const { Partners } = useStore();
  const localUrl = useLocalUrl();

  const partner = Partners.get(id);
  if (partner.isErrored) {
    return null;
  }

  if (partner.isPending) {
    return <Pill isLoading={true} />;
  }

  const content = (
    <Pill prefix={<FontAwesomeIcon icon={faHandshakeAlt} />}>
      {partner.name}
      {partner.get('is_archived') ? ' (Archived)' : ''}
    </Pill>
  );

  if (linkToItem) {
    return <Link to={localUrl(partner.getItemUrl())}>{content}</Link>;
  }
  return content;
}

export default observer(PartnerChip);
